export const networkConst = {
  USER_INACTIVE_CHECK_INTERVAL: 120000,
  MIN_TIME_CHECK_STATUS_PDF: 20,
  INTERVAL_EACH_TIME: 1000,
  FIRST_TIME_CHECK_STATUS: 500
};

export default networkConst;
